import { isAcceptanceTest } from 'hub-http/helpers/env';
import { useGetIndustryQuery } from '../../../../__generated__/chirp/com/hubspot/blueprint/industry/rpc/IndustryRpc.hooks';
export function useUserIndustry() {
  var _data$industryWithLab, _data$industryWithLab2;
  const {
    data,
    loading
  } = useGetIndustryQuery({
    skip: isAcceptanceTest()
  });
  return {
    industry: data === null || data === void 0 || (_data$industryWithLab = data.industryWithLabel) === null || _data$industryWithLab === void 0 ? void 0 : _data$industryWithLab.industry,
    label: data === null || data === void 0 || (_data$industryWithLab2 = data.industryWithLabel) === null || _data$industryWithLab2 === void 0 ? void 0 : _data$industryWithLab2.label,
    loading
  };
}